/**
 * 処分場受入
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/acceptances`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      selected_status: null,
      order_number: null,
      supplier_id: null,
      supplier_type: "Emission",
      trader_id: null,
      trader_type: "Trader",
      trader_name: null,
      carry_in_start_date: null,
      carry_in_end_date: null,
      disposal_location_id: null,
      sort_type: 'updated_date_desc',
      limit: 50,
    },
  }
}

const acceptance = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
    * 受入一覧取得
    * @param dispatch
    * @param commit
    * @param state
    * @param params
    * @return {Promise<unknown>}
    */
    index ({ dispatch, commit, state }, { params }) {
      dispatch('saveCondition', {params: params})
      const parameters = {
        ...state.condition,
        page: params.page,
        format: params.format,
      }
      let api_path
      if (parameters.format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      console.log("parameters", parameters)
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: parameters }).then(data => {
          if ((parameters.format !== 'csv')) {
            let content = data.content
            commit(types.DRIVER_ACCEPTANCE_PAGINATION, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    /**
    * 詳細取得
    * @param commit
    * @param id
    * @return {Promise<unknown>}
    */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { params }) {
      const _selected_status = (params.selected_status !== undefined) ? params.selected_status : null;
      const _order_number = (params.order_number !== undefined) ? params.order_number : state.condition.order_number;
      const _supplier_id = (params.supplier_id !== undefined) ? params.supplier_id : state.condition.supplier_id;
      const _supplier_type = (params.supplier_type !== undefined) ? params.supplier_type : state.condition.supplier_type;
      const _trader_id = (params.trader_id !== undefined) ? params.trader_id : state.condition.trader_id;
      const _trader_type = (params.trader_type !== undefined) ? params.trader_type : state.condition.trader_type;
      const _carry_in_start_date = (params.carry_in_start_date !== undefined) ? params.carry_in_start_date : state.condition.carry_in_start_date;
      const _carry_in_end_date = (params.carry_in_end_date !== undefined) ? params.carry_in_end_date : state.condition.carry_in_end_date;
      const _disposal_location_id = (params.disposal_location_id !== undefined) ? params.disposal_location_id : state.condition.disposal_location_id;
      const _sort_type = (params.sort_type !== undefined) ? params.sort_type : state.condition.sort_type;
      const _limit = (params.limit !== undefined) ? params.limit : state.condition.limit
      const conditions = {
        selected_status: _selected_status,
        order_number: _order_number,
        supplier_id: _supplier_id,
        supplier_type: _supplier_type,
        trader_id: _trader_id,
        trader_type: _trader_type,
        carry_in_start_date: _carry_in_start_date,
        carry_in_end_date: _carry_in_end_date,
        disposal_location_id: _disposal_location_id,
        sort_type: _sort_type,
        limit: _limit,
      }
      commit(types.DRIVER_ACCEPTANCE_CONDITION, { params: conditions })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_ACCEPTANCE_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_ACCEPTANCE_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    // [types.DRIVER_ACCEPTANCE_RESET_PAGINATION] (state) {
    //   Object.assign(state.pagination, getDefaultState().pagination)
    // },
    [types.DRIVER_ACCEPTANCE_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_ACCEPTANCE_CONDITION] (state, { params }) {
      Object.assign(state.condition, params)
      state.condition.selected_status = params.selected_status;
      state.condition.order_number = params.order_number
      state.condition.supplier_id = params.supplier_id
      state.condition.supplier_type = params.supplier_type
      state.condition.trader_id = params.trader_id
      state.condition.trader_type = params.trader_type
      state.condition.carry_in_start_date = params.carry_in_start_date
      state.condition.carry_in_end_date = params.carry_in_end_date
      state.condition.disposal_location_id = params.disposal_location_id
      state.condition.sort_type = params.sort_type
      state.condition.limit = params.limit
    }
  },

}

export default acceptance
